import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Children, cloneElement, ReactNode } from 'react';
import {
  StyleProp,
  StyleSheet,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

export const Menu = (props: {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}) => {
  const { rpx } = useResponsiveContext();

  // note(eric): filter falsy children so that it's permitted to add menu
  // items conditionally, such as:
  //   {someCondition && <Menu.Item ... />}
  const children = Children.toArray(props.children);

  /**
   * Try the following code to see the difference:
   * const list = Children.map(props.children, (x, i) => {
   *   console.log(`children[${i}]: ${x ? 'truthy' : 'falsy'}`);
   *   return x;
   * }) ?? [];
   * console.log('map(children).length: ', list.length);
   */
  return (
    <View
      css={`
        min-width: ${rpx(200)}px;
        border-radius: ${rpx(13)}px;
        background-color: #f2f2f2;
      `}
      style={props.style}
    >
      {/* Call Children.map will falsy children directly will make `isFirst`
          determination wrong. */}
      {children.map((child, index) =>
        cloneElement(child as any, { isFirst: index === 0 }),
      )}
    </View>
  );
};

const Item = (props: {
  title: string;
  isFirst?: boolean;
  onPress?: () => void;
  textStyle?: StyleProp<TextStyle>;
  style?: StyleProp<ViewStyle>;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      css={`
        height: ${rpx(44)}px;
        border-top-width: ${StyleSheet.hairlineWidth}px;
        border-top-color: ${props.isFirst ? 'transparent' : '#cccccc'};
      `}
      style={props.style}
    >
      <TouchableOpacity
        css={`
          padding: 0 ${rpx(15)}px;
          flex-direction: row;
          align-items: center;
          flex: 1;
        `}
        onPress={props.onPress}
      >
        <Typography.Label light size={rpx(15)} style={props.textStyle}>
          {props.title}
        </Typography.Label>
      </TouchableOpacity>
    </View>
  );
};

Menu.Item = Item;

export default Menu;
